/* eslint-disable */
import { DateMessage } from "../../common/date";

export const protobufPackage = "od_protos.web.data";

export interface LateCheckout {
  id: string;
  offerId: string;
  lateCheckoutDate?: DateMessage | undefined;
  numberOfDays: number;
  totalCostCents: number;
  costPerDayCents: number;
  securityAmountRetainedCents: number;
  numberOfFreeDays: number;
  securityDepositCents: number;
  overstayDate?: DateMessage | undefined;
}

export interface LateCheckoutCosts {
  fixedCostCents: number;
  dailyCostCents: number;
  totalCostCents: number;
}

function createBaseLateCheckout(): LateCheckout {
  return {
    id: "",
    offerId: "",
    lateCheckoutDate: undefined,
    numberOfDays: 0,
    totalCostCents: 0,
    costPerDayCents: 0,
    securityAmountRetainedCents: 0,
    numberOfFreeDays: 0,
    securityDepositCents: 0,
    overstayDate: undefined,
  };
}

export const LateCheckout = {
  fromJSON(object: any): LateCheckout {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      offerId: isSet(object.offerId) ? String(object.offerId) : "",
      lateCheckoutDate: isSet(object.lateCheckoutDate) ? DateMessage.fromJSON(object.lateCheckoutDate) : undefined,
      numberOfDays: isSet(object.numberOfDays) ? Number(object.numberOfDays) : 0,
      totalCostCents: isSet(object.totalCostCents) ? Number(object.totalCostCents) : 0,
      costPerDayCents: isSet(object.costPerDayCents) ? Number(object.costPerDayCents) : 0,
      securityAmountRetainedCents: isSet(object.securityAmountRetainedCents)
        ? Number(object.securityAmountRetainedCents)
        : 0,
      numberOfFreeDays: isSet(object.numberOfFreeDays) ? Number(object.numberOfFreeDays) : 0,
      securityDepositCents: isSet(object.securityDepositCents) ? Number(object.securityDepositCents) : 0,
      overstayDate: isSet(object.overstayDate) ? DateMessage.fromJSON(object.overstayDate) : undefined,
    };
  },

  toJSON(message: LateCheckout): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.offerId !== "") {
      obj.offerId = message.offerId;
    }
    if (message.lateCheckoutDate !== undefined) {
      obj.lateCheckoutDate = DateMessage.toJSON(message.lateCheckoutDate);
    }
    if (message.numberOfDays !== 0) {
      obj.numberOfDays = Math.round(message.numberOfDays);
    }
    if (message.totalCostCents !== 0) {
      obj.totalCostCents = Math.round(message.totalCostCents);
    }
    if (message.costPerDayCents !== 0) {
      obj.costPerDayCents = Math.round(message.costPerDayCents);
    }
    if (message.securityAmountRetainedCents !== 0) {
      obj.securityAmountRetainedCents = Math.round(message.securityAmountRetainedCents);
    }
    if (message.numberOfFreeDays !== 0) {
      obj.numberOfFreeDays = Math.round(message.numberOfFreeDays);
    }
    if (message.securityDepositCents !== 0) {
      obj.securityDepositCents = Math.round(message.securityDepositCents);
    }
    if (message.overstayDate !== undefined) {
      obj.overstayDate = DateMessage.toJSON(message.overstayDate);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LateCheckout>, I>>(base?: I): LateCheckout {
    return LateCheckout.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LateCheckout>, I>>(object: I): LateCheckout {
    const message = createBaseLateCheckout();
    message.id = object.id ?? "";
    message.offerId = object.offerId ?? "";
    message.lateCheckoutDate = (object.lateCheckoutDate !== undefined && object.lateCheckoutDate !== null)
      ? DateMessage.fromPartial(object.lateCheckoutDate)
      : undefined;
    message.numberOfDays = object.numberOfDays ?? 0;
    message.totalCostCents = object.totalCostCents ?? 0;
    message.costPerDayCents = object.costPerDayCents ?? 0;
    message.securityAmountRetainedCents = object.securityAmountRetainedCents ?? 0;
    message.numberOfFreeDays = object.numberOfFreeDays ?? 0;
    message.securityDepositCents = object.securityDepositCents ?? 0;
    message.overstayDate = (object.overstayDate !== undefined && object.overstayDate !== null)
      ? DateMessage.fromPartial(object.overstayDate)
      : undefined;
    return message;
  },
};

function createBaseLateCheckoutCosts(): LateCheckoutCosts {
  return { fixedCostCents: 0, dailyCostCents: 0, totalCostCents: 0 };
}

export const LateCheckoutCosts = {
  fromJSON(object: any): LateCheckoutCosts {
    return {
      fixedCostCents: isSet(object.fixedCostCents) ? Number(object.fixedCostCents) : 0,
      dailyCostCents: isSet(object.dailyCostCents) ? Number(object.dailyCostCents) : 0,
      totalCostCents: isSet(object.totalCostCents) ? Number(object.totalCostCents) : 0,
    };
  },

  toJSON(message: LateCheckoutCosts): unknown {
    const obj: any = {};
    if (message.fixedCostCents !== 0) {
      obj.fixedCostCents = Math.round(message.fixedCostCents);
    }
    if (message.dailyCostCents !== 0) {
      obj.dailyCostCents = Math.round(message.dailyCostCents);
    }
    if (message.totalCostCents !== 0) {
      obj.totalCostCents = Math.round(message.totalCostCents);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LateCheckoutCosts>, I>>(base?: I): LateCheckoutCosts {
    return LateCheckoutCosts.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LateCheckoutCosts>, I>>(object: I): LateCheckoutCosts {
    const message = createBaseLateCheckoutCosts();
    message.fixedCostCents = object.fixedCostCents ?? 0;
    message.dailyCostCents = object.dailyCostCents ?? 0;
    message.totalCostCents = object.totalCostCents ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
